import { useState, useRef, useEffect } from 'react';
import strFunc from '@/lib/lyg/string';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios/index";
import XcolumnFunc from '@/pcomponents/common/xcolumn/xcolumn/xcolumn_func';
import TextBookSortManageList from "./area/list";

function TextBookSortManageSort(props: any) {
  let myProps = {
    listOpt: {},
    closePopup: () => { },
    refreshData: (inData: any) => { },
    callbackData: (inData: any) => { },
    ...props
  };

  const [listOpt, setListOpt] = useState<any>({
    s_subject: "",
    s_category_seq: "",
    s_sort1_seq: "",
    s_sort2_seq: "",
    s_sort3_seq: "",
  });
  let subject_arr = XcolumnFunc.getSortByTableKey({ 'table': 'study_title', 'key': 'a_subject_sort' });
  const [category_arr, set_category_arr] = useState<any>([]);
  const [sort1_arr, set_sort1_arr] = useState<any>([]);
  const [sort2_arr, set_sort2_arr] = useState<any>([]);
  const [sort3_arr, set_sort3_arr] = useState<any>([]);

  useEffect(() => {
    get_textbook_sort_by_ajax({ s_type: "category" });
  }, []);

  const get_textbook_sort_by_ajax = (inData: any) => {
    let opt_obj = {
      s_type: "sort1",
      s_par_id: "mtextbook_sort",
      s_par_seq: "",
      ...inData
    };

    let formJsonData = {
      s_type: opt_obj.s_type,
      s_par_id: opt_obj.s_par_id,
      s_par_seq: opt_obj.s_par_seq,
      order_id: "a_order_num",
      "is_need_count": "",
      "is_need_info_arr": "1",
      "is_no_limit": "1",
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/main/textbook/sort/list', formJsonData, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          if (opt_obj.s_type == "sort1") {
            set_sort1_arr(response.data["data"]["info_arr"]);
          } else if (opt_obj.s_type == "sort2") {
            set_sort2_arr(response.data["data"]["info_arr"]);
          } else if (opt_obj.s_type == "sort3") {
            set_sort3_arr(response.data["data"]["info_arr"]);
          } else if (opt_obj.s_type == "category") {
            set_category_arr(response.data["data"]["info_arr"]);
          }
        }
      });
  };

  return (
    <div>
      <div className="text-left">
        <select className='search-input' value={listOpt.s_subject} style={{ width: "150px" }}
          onChange={(e) => {
            setListOpt({
              ...listOpt,
              s_subject: e.target.value,
              s_category_seq: "",
              s_sort1_seq: "",
              s_sort2_seq: "",
              s_sort3_seq: "",
            });
            set_sort1_arr([]);
            set_sort2_arr([]);
            set_sort3_arr([]);

            if (strFunc.is_empty(e.target.value)) {
              set_category_arr([]);
            } else {
              get_textbook_sort_by_ajax({
                s_type: "category",
                s_par_id: "subject",
                s_par_seq: e.target.value
              });
            }
          }}
        >
          <option value="">선택없음</option>
          {subject_arr.map((item: any, idx: number) => {
            return (
              <option key={idx} value={item.value}>{item.text}</option>
            );
          })}
        </select>
      </div>
      <table style={{ width: "100%" }}>
        <colgroup>
          <col width={"25%"}></col>
          <col width={"25%"}></col>
          <col width={"25%"}></col>
          <col width={"25%"}></col>
        </colgroup>
        <tbody>
          <tr>
            <td style={{ verticalAlign: "top" }}>
              <div>
                <TextBookSortManageList
                  listOpt={{
                    s_type: "category",
                    s_par_id: "subject",
                    s_par_seq: listOpt.s_subject,
                  }}
                  info_arr={category_arr}
                  set_info_arr={set_category_arr}
                  list={() => {
                    get_textbook_sort_by_ajax({ s_type: "category", s_par_id: "subject", s_par_seq: listOpt.s_subject });
                  }}
                  set_select_seq={(select_seq: any) => {
                    setListOpt({
                      ...listOpt,
                      s_category_seq: select_seq,
                      s_sort1_seq: "",
                      s_sort2_seq: "",
                      s_sort3_seq: "",
                    });
                    if (strFunc.is_empty(select_seq)) {
                      set_sort1_arr([]);
                    } else {
                      get_textbook_sort_by_ajax({ s_type: "sort1", s_par_seq: select_seq });
                    }
                    set_sort2_arr([]);
                    set_sort3_arr([]);
                  }}
                ></TextBookSortManageList>
              </div>
            </td>
            <td style={{ verticalAlign: "top" }}>
              <div>
                <TextBookSortManageList
                  listOpt={{
                    s_type: "sort1",
                    s_par_id: "mtextbook_sort",
                    s_par_seq: listOpt.s_category_seq,
                  }}
                  info_arr={sort1_arr}
                  set_info_arr={set_sort1_arr}
                  list={() => {
                    get_textbook_sort_by_ajax({ s_type: "sort1", s_par_seq: listOpt.s_category_seq });
                  }}
                  set_select_seq={(select_seq: any) => {
                    setListOpt({
                      ...listOpt,
                      s_sort1_seq: select_seq,
                      s_sort2_seq: "",
                      s_sort3_seq: "",
                    });
                    if (strFunc.is_empty(select_seq)) {
                      set_sort2_arr([]);
                    } else {
                      get_textbook_sort_by_ajax({ s_type: "sort2", s_par_seq: select_seq });
                    }
                    set_sort3_arr([]);
                  }}
                ></TextBookSortManageList>
              </div>
            </td>
            <td style={{ verticalAlign: "top" }}>
              <div>
                <TextBookSortManageList
                  listOpt={{
                    s_type: "sort2",
                    s_par_id: "mtextbook_sort",
                    s_par_seq: listOpt.s_sort1_seq,
                  }}
                  info_arr={sort2_arr}
                  set_info_arr={set_sort2_arr}
                  list={() => {
                    get_textbook_sort_by_ajax({ s_type: "sort2", s_par_seq: listOpt.s_sort1_seq });
                  }}
                  set_select_seq={(select_seq: any) => {
                    setListOpt({
                      ...listOpt,
                      s_sort2_seq: select_seq,
                      s_sort3_seq: "",
                    });
                    if (strFunc.is_empty(select_seq)) {
                      set_sort3_arr([]);
                    } else {
                      get_textbook_sort_by_ajax({ s_type: "sort3", s_par_seq: select_seq });
                    }
                  }}
                ></TextBookSortManageList>
              </div>
            </td>
            <td style={{ verticalAlign: "top" }}>
              <div>
                <TextBookSortManageList
                  listOpt={{
                    s_type: "sort3",
                    s_par_id: "mtextbook_sort",
                    s_par_seq: listOpt.s_sort2_seq,
                  }}
                  info_arr={sort3_arr}
                  set_info_arr={set_sort3_arr}
                  list={() => {
                    get_textbook_sort_by_ajax({ s_type: "sort3", s_par_seq: listOpt.s_sort2_seq });
                  }}
                  set_select_seq={(select_seq: any) => {
                    setListOpt({
                      ...listOpt,
                      s_sort3_seq: select_seq,
                    });
                  }}
                ></TextBookSortManageList>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
export default TextBookSortManageSort;